const showrooms = {
  namespaced: true,

  state: {
    showrooms: [],
  },

  getters: {
    showroomBySlug: state => slug => {
      return state.showrooms.find(showroom => showroom.slug == slug)
    },

    hasShowrooms: state => state.showrooms.length > 0
  },

  mutations: {
    setShowrooms (state, showrooms) {
      state.showrooms = showrooms
    }
  }
}

export default showrooms
